import { LOOKUP_API } from "../../apiList";

export default class StateGateway {
    get() {
        return LOOKUP_API.get("/states");
    }
}
